import React from 'react';
import { TrackingService } from '@/util/tracking/tracking';

export const TrackingServiceContext = React.createContext<TrackingService | undefined>(undefined);

export function useTrackingService(): TrackingService {
  const trackingService = React.useContext(TrackingServiceContext);

  if (!trackingService) {
    throw new Error('No tracking-service context value was provided.');
  }

  return trackingService;
}
